import { useQuery } from "@apollo/client";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, CircularProgress, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import ZineCoversEditFormCont from "../containers/ZineCoversEditFormCont";
import { QUERY_ZINE_COVER } from "../gql/queries/zineCover";
import { Spacing } from "../types/enum";

const ZineCoversEditPage: React.FC = () => {
  const params = useParams<Record<string, string>>();

  const { data, loading } = useQuery(QUERY_ZINE_COVER, {
    fetchPolicy: "network-only",
    variables: {
      id: params?.zineCoverId,
    },
  });

  if (loading) {
    return <CircularProgress />;
  }

  const zineCover = data?.adminGetZineCover;

  return (
    <>
      <Box display="flex" alignItems="center" mb={Spacing.m}>
        <Link color="inherit" component={RouterLink} to="/zine-covers">
          <Box mr={Spacing.sm}>
            <ArrowBackIcon />
          </Box>
        </Link>

        <Typography variant="h3" color="textPrimary">
          Cover
        </Typography>
      </Box>

      <ZineCoversEditFormCont zineCover={zineCover} />
    </>
  );
};

export default ZineCoversEditPage;
